<template lang="html">
  <b-nav class="main-menu" align="center">
    <b-nav-item v-for="route in routes" @click="route.action ? route.action() : $router.push({name:route.name})" :key="route.name" :active="$route.name == route.name">
      {{ route.label }}
    </b-nav-item>
    <b-nav-item class="logout-button" v-if="$store.user">
      <div class="nome-utente" >
         {{$store.user.name}}
         {{'|'}}
         {{$store.user.company}}
      </div>
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    routes() {
      let ret = []
      ret.push({
        name: 'home',
        label: 'Ricerca Pallet',
      })
      if (!this.$store.token) {
        ret.push({
          name: 'login',
          label: 'Login',
          action: () => {
            this.$store.show_login = true
          }
        })
        ret.push({
          name: 'signup',
          label: 'Registrati',
          action: () => {
            this.$store.show_signup = true
          }
        })
      } else {
        if (['admin'].includes(this.$store.user.type)) {
          ret.push({
            name: 'users',
            label: 'Utenti',
          })
        }
        if (['admin'].includes(this.$store.user.type)) {
          ret.push({
            name: 'orders',
            label: 'Richieste',
          })
          ret.push({
            name: 'products',
            label: 'Prodotti',
          })
          ret.push({
            name: 'products-list',
            label: 'Gestione Prodotti',
          })
        }
        if (['partner' , 'client'].includes(this.$store.user.type)) {
          ret.push({
            name: 'user-area',
            label: 'Area Utente',
          })
        }
        ret.push({
          name: 'logout',
          label: 'Logout',
        })
      }
      return ret
    }
  }
}
</script>

<style lang="scss">
.main-menu {
    background-color: #f1f1f1;
    border-bottom: 1px solid var(--primary);
    padding: 0.6rem 0 0.8rem;
    padding-top:30px;
    padding-bottom:30px;
    margin-bottom: 2rem!important;
    .nav-link {
        color: #666;
        padding: 0.6rem 1rem;
        text-align: center;
        outline: none;
        transition: 0.4s;
        font-size: 1.2rem;
        border-bottom: 2px solid transparent;
        &.active {
            color: var(--primary) !important;
            background-color: inherit !important;
            // text-decoration: underline;
            border-bottom-color: var(--primary);
        }
    }
}
.pulsante-logout{
  background-color:#81bb5d;
  color: white;
  border:1px solid #81bb5d;
  border-radius:30px;
  padding: 4px 40px;
}
.logout-button{
  position: absolute;
  right: 0px;
}
.nome-utente{
  padding-right:20px;
}
.logout-button a{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
</style>
